import React from 'react';
import { Badge } from '../../../ui/badge';
import { SectionHeaderBlock as SectionHeaderBlockType } from '../../../../types/report-builder';

interface Props {
  block: SectionHeaderBlockType;
}

const SectionHeaderBlock: React.FC<Props> = ({ block }) => {
  return (
    <div className="my-8 flex items-end justify-between gap-4 border-b border-border/70 pb-3">
      <div>
        <h2 className="font-jakarta text-lg font-bold tracking-[-0.02em] text-foreground">
          {block.title}
        </h2>
        {block.description && (
          <p className="mt-1 text-sm leading-[1.7] text-muted-foreground">{block.description}</p>
        )}
      </div>
      <Badge variant="secondary" className="shrink-0">
        Section
      </Badge>
    </div>
  );
};

export default SectionHeaderBlock;
